module.exports = __webpack_public_path__ + "img/tree-08-a-trunk.0b5313d0.png";